module.exports = __webpack_public_path__ + "img/mx_seguroportatil.d69e8188.png";